module.exports = __webpack_public_path__ + "img/product-registration.dc52677c.png";